<template>
    <el-dialog title="个性化设置" :visible.sync="showDialog" append-to-body width="600px">
      <el-tabs v-model="activeName" type="card" @tab-click="tabClick">
        <el-tab-pane label="签名设置" name="setSign">
          <el-form :model="ruleForm" size="small" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="特殊字体">
              <el-radio-group v-model="ruleForm.font">
                <el-radio label="hwxk">华文行楷</el-radio>
                <el-radio label="mbxs2">毛笔行书</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="预览">
              <p class="preview" :style="{'font-family': ruleForm.font}">{{ruleForm.name}}</p>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"  @click="submitForm('ruleForm')">{{disabledBtn?'签名已设置':'立即创建'}}</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="告知视频上传" name="uploadVideo">
          <VideoUpload :notaryId="notaryId" :videoId="videoId" @sumitSuccess="videoUploadSuccess"/>
        </el-tab-pane>
        <el-tab-pane label="视频录制">
          <RecordVideo :notaryId="notaryId" @sumitSuccess="videoUploadSuccess" />
        </el-tab-pane>
      </el-tabs>

      <canvas v-show="false" class="myCanvas" ref="canvas" width="473" height="270"></canvas>
    </el-dialog>
</template>

<script>
import {dataURLtoFile} from '@/utils/tools';
import VideoUpload from './personalization/video-upload';
import RecordVideo from './personalization/record-video';

export default {
  props: {
    userId: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    disabledBtn: {
      type: Boolean,
      required: false
    },
    notaryId: {
      type: Number | null | String,
      required: true
    },
    videoId: {
      type: Number | null | String,
      required: true
    },
  },
  components: {
    VideoUpload,
    RecordVideo
  },
  data() {
    return {
      showDialog: false,
      ruleForm: {
        name: '',
        font: 'hwxk'
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
      },
      imageData: '',
      applySignFormData: new FormData(),
      activeName: 'setSign'
    }
  },
  watch: {
    name: {
      immediate: true,
      handler(newValue) {
        console.log(newValue)
        this.ruleForm.name = newValue;
      }
    }
  },
  methods: {
    open() {
      this.showDialog = true;
    },
    close() {
      this.showDialog = false;
    },
    tabClick() {},
    init() {
      let canvas = this.$refs.canvas;
      this.ctx = canvas.getContext('2d');
      this.ctx.globalAlpha = 0;
      this.ctx.fillStyle = "#fff";
      this.ctx.fillRect(0,0, canvas.width, canvas.height);
      this.ctx.globalAlpha = 1;
      this.ctx.font = `120px ${this.ruleForm.font}`;
      this.ctx.fillStyle = "#0f63de";
      this.ctx.textAlign = "center";
      this.ctx.textBaseline = "middle";
      this.ctx.fillText(this.ruleForm.name, 230, 130);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.init();
          this.imageData = this.$refs.canvas.toDataURL("image/png", 1.0);
          let file = dataURLtoFile(this.imageData, '签名图片');
          this.applySignFormData.append("file", file);
          this.applySignFormData.append("userId", this.userId);
          this.$api.applySign(this.applySignFormData).then(res => {
            if (res.data.code === '200') {
              this.$message({
                message: '签名设置成功',
                type: 'success'
              });
              this.$emit('success');
              this.close();
            } else {
              this.$message({
                message: res.data.msg,
                type: 'warning'
              });
            }
          }).finally(() => {
            this.applySignFormData = new FormData();
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    videoUploadSuccess() {
      this.$emit('success');
      this.close();
    }
  }
}
</script>
<style scoped>
.ttf{
  font-size: 50px;
  font-family: 'hwxk';
}
.myCanvas{
  border: 1px solid #DCDFE6;
  border-radius: 4px;
}
.preview{
  font-size: 40px;
  color: #0f63de;
}
.ruleForm{
  width: 420px;
}
</style>
